
import sharedStyles from 'styles/css/SharedStyles.module.scss';
// import styles from 'styles/css/Main.module.scss';
// import drawerStyles from 'styles/css/Drawer.module.scss';
// import actionStyles from 'styles/css/ActionStyles.module.scss';
// import Logo from 'styles/images/logo/logo512.png';

import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import discountStyles from 'styles/css/DiscountStyles.module.scss';

const Discounts = () => {

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtn />
                
                <div className={discountStyles.box}>
                    <div className={[sharedStyles['w-full'], sharedStyles.flex, sharedStyles.justifyCenter, discountStyles.badgeBox].join(' ')}>
                        <span className={[sharedStyles.flex, sharedStyles.itemsCenter, discountStyles.badge].join(' ')}>
                            <span className={discountStyles.discountPercent}>٪۵۰</span>
                            <span className={[discountStyles.discountTxt, sharedStyles['mr-[5px]']].join(' ')}> تخفیف</span>
                        </span>
                    </div>
                    <ul>
                        <li>
                            ایام تولد نبی مکرم اسلام  و تولد حضرت فاطمه الزهرا  و ایام تولد ائمه اطهار(صلوات الله وسلامه علیهم) ،ویزیت شامل ۵۰ درصد تخفیف می‌باشد.                        
                        </li>
                        <li>
                            اعیاد مسلمین  شامل عید سعید مبعث،عید  غدیر خم،عید  فطر، عید قربان و عید نوروز ،ویزیت شامل ۵۰ درصد تخفیف می‌باشد
                        </li>
                    </ul>
                </div>


                <div className={discountStyles.box}>
                    <div className={[sharedStyles['w-full'], sharedStyles.flex, sharedStyles.justifyCenter, discountStyles.badgeBox].join(' ')}>
                        <span className={[sharedStyles.flex, sharedStyles.itemsCenter, discountStyles.badge].join(' ')}>
                            <span className={discountStyles.discountPercent}>٪۳۰</span>
                            <span className={[discountStyles.discountTxt, sharedStyles['mr-[5px]']].join(' ')}> تخفیف</span>
                        </span>
                    </div>
                    <ul>
                        <li>
                            ایتام عزیز و خانواده های محترم ایتام
                        </li>
                        <li>
                            خانواده عزیز افتخارآفرینان و مدال آوران المپیادهای علمی،ورزشی و فرهنگی هنری
                        </li>
                        <li>
                            خانواده کارگران محترم و عزیز صنایع تولیدی و خدماتی
                        </li>
                        <li>
                            خانواده محترم افراد تحت پوشش کمیته امداد و سازمان بهزیستی
                        </li>
                        <li>
                            خانواده محترم فرهنگیان مقطع ابتدایی
                        </li>
                    </ul>
                </div>



                <div className={discountStyles.box}>
                    <div className={[sharedStyles['w-full'], sharedStyles.flex, sharedStyles.justifyCenter, discountStyles.badgeBox].join(' ')}>
                        <span className={[sharedStyles.flex, sharedStyles.itemsCenter, discountStyles.badge].join(' ')}>
                            <span className={discountStyles.discountPercent}>٪٢۰</span>
                            <span className={[discountStyles.discountTxt, sharedStyles['mr-[5px]']].join(' ')}> تخفیف</span>
                        </span>
                    </div>
                    <ul>
                        <li>
                            خانواده های محترم و عزیز اساتید دانشگاه‌های سراسر کشور عزیزمان ایران
                        </li>
                        <li>
                            خانواده های هنرمندان عزیز (همه رشته ها)
                            <p style={{textIndent: '1em', marginTop: '0'}}>به پاس زحمات بی دریغ شما در اعتلای علم و هنر و فرهنگ این سرزمین، تخفیف 20درصدی برای خدمات پزشکی گروه Dr20 در نظر گرفته ایم.</p>
                        </li>
                    </ul>
                </div>


            </div>
                
        </div>

    );
}

export default Discounts;